export default "__VITE_ASSET__UZYrksJ4__"